import axios from "axios";


export const getDocumentInfo = async (docId) => {
  const accessKey = localStorage.getItem('accessToken')
    
  const result = await axios.get(`/accounting/api/document/info?docId=${docId}`);
  return result.data;
};


export const getDocument = async (hash) => {
    
  const result = await axios.get(`/accounting/api/partner/document/${hash}`,{
    headers: {
      'X-Partner-Password': sessionStorage.getItem('partnerPassword'+hash) || '',
      'uu-id': hash
    },
  });
  return result.data;
};

export const checkDocument = async (hash) => {
    
  const result = await axios.get(`/accounting/api/partner/document/check/${hash}`,{
    headers: {
      'X-Partner-Password': sessionStorage.getItem('partnerPassword'+hash) || '',
      'uu-id': hash
    },
  });
  return result.data;
};

export const checkDocumentOpts = async (hash) => {

  const result = await axios.get(`/accounting/api/partner/document/settings/${hash}`,{
    headers: {
      'X-Partner-Password': sessionStorage.getItem('partnerPassword'+hash) || '',
      'uu-id': hash
    },
  });
  return result.data;
};

export const setDocumentStatus = async (hash, status, note) => {
    
  const result = await axios.put(`/accounting/api/partner/document/status/${status}/${hash}`,note,{
    headers: {
      'X-Partner-Password': sessionStorage.getItem('partnerPassword'+hash) || '',
      'uu-id': hash,
      'Content-Type': 'text/plain'
    },
  });
  return result.data;
};

export const setDocumentForms = async (hash, data) => {
    
  const result = await axios.post(`/accounting/api/partner/document/${hash}`, data, {
    headers: {
      'X-Partner-Password': sessionStorage.getItem('partnerPassword'+hash) || '',
      'uu-id': hash
    },
  });
  return result.data;
};
